export const state = {
  topNavigation: null,
  sideNavigation: {
    expanded: false,
  },
  languages: [],
  alert: null,
};
